import React from "react";
import { Stack, Typography } from "@mui/material";
import SelectApiInput from "../../../../components/common/input/SelectApiInput";
import { useDispatch, useSelector } from "react-redux";
import { updateRoute } from "../../../../redux/reducers/booking.reducer";
import Journeys from "./journeys";

interface ILeft {
  headerHeight: string;
}

function Left({ headerHeight }: ILeft) {
  const { route } = useSelector((state: any) => state.booking);
  const dispatch = useDispatch();

  return (
    <Stack
      gap={2}
      sx={{
        width: "100%",
        height: `calc(100vh - ${headerHeight} - 16px)`,
        overflow: "auto",
        backgroundColor: "background.paper",
        p: 1,
        borderRadius: "10px",
      }}
    >
      <SelectApiInput
        direction="column"
        label="Tuyến đường"
        apiCode="route"
        getOptionLabel={(option) => option.name}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["name"]}
        placeholder="Chọn tuyến đường"
        selectTitle="Tìm và chọn tuyến đường"
        placeholderSearch="Tìm theo tên tuyến đường"
        value={route}
        onChange={(val) => dispatch(updateRoute(val))}
      />
      {/* <Stack
        gap={1}
        sx={{
          p: 1,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "10px",
        }}
      >
        <Typography sx={{ fontWeight: 500 }}>Ngày đi</Typography>
        <DateCalendar
          dayOfWeekFormatter={(date) => date.format("ddd")}
          value={!!date ? moment(date) : null}
          onChange={(val) => {
            dispatch(updateDate(moment(val).toISOString()));
          }}
          sx={{
            backgroundColor: "background.default",
            borderRadius: "10px",
            width: "100%",
          }}
        />
      </Stack> */}
      {/* Lịch trình */}
      {!!route ? (
        <Journeys />
      ) : (
        <Typography sx={{ textAlign: "center", fontStyle: "italic" }}>
          Chọn tuyến đường
        </Typography>
      )}
    </Stack>
  );
}

export default Left;
